import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox } from '@mui/material';
import { useEffect, useState } from 'react';

import { createFilterOptions } from '@mui/material/Autocomplete';
import { FormikTextField } from '../../../common/formik-material-ui';

export default function NumberTabAutoComplete({
  items,
  index,
  formik,
  getOptionLabel,
  field,
  label,
  selected,
  dataPup,
  ...rest
}) {
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  useEffect(() => {
    if (formik.values.numberActions[index].selectAll === true) {
      setSelectedOptions(items);
    } else {
      setSelectedOptions(selected);
    }
  }, []);
  const allSelected = (items) => items.length === selectedOptions.length;
  const filter = createFilterOptions();

  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={5}
      options={['selectAll', ...items] ?? []}
      value={selectedOptions}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, anotherOption) => option === anotherOption}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [...filtered];
      }}
      onChange={(event, value, reason, details) => {
        if (reason === 'selectOption' || reason === 'removeOption') {
          if (value.find((option) => option === 'selectAll')) {
            if (!allSelected(items)) {
              setSelectedOptions(items);
              formik.setFieldValue(`numberActions.${index}.selectAll`, true);
            } else {
              setSelectedOptions([]);
              formik.setFieldValue(`numberActions.${index}.selectAll`, false);
            }
          } else {
            setSelectedOptions(value);
            formik.setFieldValue(field, value);
            formik.setFieldValue(`numberActions.${index}.selectAll`, false);
          }
        } else if (reason === 'clear') {
          setSelectedOptions([]);
          formik.setFieldValue(field, []);
          formik.setFieldValue(`numberActions.${index}.selectAll`, false);
        }
      }}
      renderOption={(props, option, { selected }) => {
        const selectAllProps =
          props?.key === 'selectAll' ? { checked: allSelected(items) } : {};
        const { key, ...optionProps } = props;
        return (
          <li key={option} {...optionProps}>
            <Checkbox
              color="primary"
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              style={{ marginRight: 8 }}
              checked={selected}
              {...selectAllProps}
              data-pup="routing-number-autocomplete-item"
            />
            {getOptionLabel(option)}
          </li>
        );
      }}
      {...rest}
      renderInput={(params) => (
        <FormikTextField
          variant="outlined"
          name={field}
          formik={formik}
          {...params}
          label={`Select ${label}`}
          placeholder={`Search ${label}`}
          data-pup={dataPup ?? undefined}
          onInput={(event: any) => {
            event.persist();
            event?.target?.value === '' &&
              formik.setFieldValue(field, selectedOptions);
          }}
        />
      )}
    />
  );
}
